'use strict';

const StringLengthVerifierContrib = require('./../contribs/StringLengthVerifierContrib');
const Verifier = require('./../../system/Verifier');

const Password = (module.exports = Verifier.define(StringLengthVerifierContrib, {
	type: 'PasswordVerifier',

	lang: require('./PasswordVerifierLang'),

	minLength: 6,
	maxLength: 64
}));

Password.INSTANCE = new Password();
